var map = {
	"./africano.jpg": 280,
	"./bara.jpg": 281,
	"./exu.png": 282,
	"./iansa.png": 283,
	"./ibeji.png": 542,
	"./iemanja.png": 284,
	"./iroco.png": 285,
	"./logunede.png": 543,
	"./nana.png": 286,
	"./oba.png": 544,
	"./ogum.png": 287,
	"./omulu.png": 288,
	"./omulu2.png": 545,
	"./ossaim.png": 546,
	"./oxala.jpg": 289,
	"./oxossi.png": 290,
	"./oxum.png": 291,
	"./oxumare.png": 547,
	"./pomba.jpg": 292,
	"./pretoVelho.jpg": 548,
	"./pretovelho.png": 293,
	"./trancarua.png": 549,
	"./xango.png": 294
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 279;